import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';

import { AnalyticsContainer } from 'js/analytics';
import { AnalyticsExperienceBoundary } from 'js/analytics/AnalyticsExperienceBoundary';
import {
  AutotestAnalyticsProvider,
  resolveSurfaces,
} from 'js/analytics/autotest/AutotestAnalytics';
import 'js/i18n/translations/analytics_dashboard';
import renderOnsitePing from 'js/onsite_pings/onsite_pings.wjs';
import assignGlobal from 'js/utils/assign_global';
import registerForRails from 'js/utils/registerForRails';
import { setUpFindReaders } from 'js/profiles/setUpFindReaders';
import '../stylesheets/user_cards.scss';

import PaywallPage from 'js/analytics/pages/PaywallPage';
import ReadersExportModal from 'js/readers/ReadersExportModal';
import ProfileVisitorsExportModal from 'js/profile_visitors/ProfileVisitorsExportModal';

assignGlobal('Aedu', { renderOnsitePing: renderOnsitePing });

// Click and impression tracking for the Papers table's Find Readers column.
// Delegated on document, so it does not care that the buttons mount later, as
// each row's eligibility request lands, nor that sorting re-renders them.
setUpFindReaders();

registerForRails(
  {
    // NATIONAL PARKS: Please remove this disable and try to fix it if you're here
    // eslint-disable-next-line react/display-name
    Analytics: ({ params, autotestArm, newAnalytics }) => (
      <Provider store={Aedu.ReduxStore}>
        <AutotestAnalyticsProvider value={resolveSurfaces(autotestArm)}>
          <BrowserRouter
            basename={`${encodeURIComponent(params.page_name)}/Analytics`}
          >
            <AnalyticsExperienceBoundary
              newAnalytics={newAnalytics}
              basePath={`/${encodeURIComponent(params.page_name)}/Analytics`}
            >
              <AnalyticsContainer />
            </AnalyticsExperienceBoundary>
          </BrowserRouter>
        </AutotestAnalyticsProvider>
      </Provider>
    ),
    PaywallPage,
    ReadersExportModal,
    ProfileVisitorsExportModal,
  },
  ['js/analytics'],
);
